<template>
  <div class="last">
    <div class="last-down">
      <div class="left">
        <div class="left-top">
          <div class="eveHang" @click="tiao">首页</div>
          <div class="eveHang" @click="fqd">产品中心</div>
          <div class="eveHang" @click="tiao3">解决方案</div>
          <div class="eveHang" @click="tiao4">应用案例</div>
          <div class="eveHang" @click="tiao5">关于我们</div>
        </div>
        <div class="left-bottom">
          <img src="../../assets/bottom-logo.png" alt="" />
          <div class="tel">
            <img src="../../assets/last/tel.png" alt="" />
            <span>400-806-9190</span>
          </div>
        </div>
        <!-- <div class="eveHang">
          <span @click="tiao">首页</span>
          <span @click="tiao4">应用案列</span>
          <span @click="tiao5">关于我们</span>
        </div>
        <div class="eveHang">
          <span>产品中心:</span>
          <span class="more2" @click="fqd">智能防窃电系统</span>
          <span class="more2" @click="yccb">远程抄表系统</span>
          <span class="more2" @click="bms">BMS蓄电池智能监测系统方案</span>
          <span class="more2" @click="hotline">政府热线/政务服务便民热线</span>
        </div>
        <div class="eveHang">
          <span>解决方案:</span>
          <span class="more2" @click="tiao3">机房及基站防窃电系统技术方案</span>
          <span class="more2" @click="tiao32">BMS蓄电池智能监测系统方案</span>
          <span class="more2" @click="tiao33">远程抄表解决方案</span>
          <span class="more2" @click="tiao34">铅酸电池修复解决方案</span>
        </div> -->
      </div>
      <div class="right">
        <div class="top">
          <el-input
            v-model="form.name"
            placeholder="姓名"
            style="width: 150px"
          ></el-input>
          <el-input
            v-model="form.mobile"
            placeholder="电话"
            style="width: 150px"
          ></el-input>
          <el-input
            v-model="form.email"
            placeholder="Email"
            style="width: 150px"
          ></el-input>
        </div>

        <div class="more">
          <el-input
            type="textarea"
            rows="4"
            placeholder="请输入您的留言"
            v-model="form.message"
          ></el-input>
        </div>
        <el-button
          type="primary"
          size="medium"
          style="margin-left: 90%"
          @click="submit"
          >提交</el-button
        >
      </div>
      <div>
        <img src="../../assets/last/weixin.png" alt="" />
        <!-- <div class="tel">
          <img src="../../assets/last/tel.png" alt="" />
          <span>400-806-9190</span>
        </div> -->
      </div>
    </div>
    <!-- <div class="beian">
      <span>@北京云信观远信息技术有限公司</span>
      <span @click="goBei">京ICP备2021034257号-2</span>
    </div> -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {
        name: "",
        mobile: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    submit() {
      if (this.form.mobile !== "") {
        axios({
          method: "post",
          url: "/api/homepage/register",
          data: this.form,
        }).then((res) => {
          console.log(res);
          if (res.status == 200) {
            this.$message({
              message: "提交成功",
              type: "success",
              offset: 110,
            });
          }
        });
      } else {
        this.$message({
          message: "请您至少输入电话信息",
          type: "warning",
          offset: 110,
        });
      }
    },
    goBei() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
      console.log(1);
    },
    tiao() {
      this.$router.push("/");
      console.log(1);
    },
    // tiao2() {
    //   this.$router.push("/production/fqd");
    //   console.log(1);
    // },
    tiao3() {
      this.$router.push({
        path: "/solution",
        query: {
          id: "1",
        },
      });
    },
    tiao32() {
      this.$router.push({
        path: "/solution",
        query: {
          id: 2,
        },
      });
    },
    tiao33() {
      this.$router.push({
        path: "/solution",
        query: {
          id: 3,
        },
      });
    },
    tiao34() {
      this.$router.push({
        path: "/solution",
        query: {
          id: 4,
        },
      });
    },
    tiao4() {
      this.$router.push("/example");
      console.log(1);
    },
    tiao5() {
      this.$router.push("/aboutus");
      console.log(1);
    },
    fqd() {
      this.$router.push({ path: "/production/fqd" });
    },
    yccb() {
      this.$router.push({ path: "/production/yccb" });
    },
    bms() {
      this.$router.push({ path: "/production/BMS" });
    },
    hotline() {
      this.$router.push({ path: "/production/hotline" });
    },
  },
};
</script>
<style lang="less" scoped>
.last {
  width: 100%;
  height: 332px;
  //   border: 1px solid red;
  background: #0e2033;
  opacity: 1;

  .last-down {
    width: 100%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0 100px;
    align-items: center;
    // border: 1px solid red;
    .left {
      width: 45%;
      height: 280px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      .left-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #494949;
      }
      .eveHang {
        padding-top: 80px;
        padding-bottom: 40px;
        display: flex;
        flex-direction: column;
        // border: 1px solid red;
        justify-content: space-around;
        color: #fff;
        .more2 {
          font-size: 14px;
          cursor: pointer;
        }
        .more2:hover {
          color: skyblue;
        }
      }
      // border: 1px solid red;
      // .top {
      //   width: 100%;
      //   height: 155px;
      //   border-bottom: 1px solid #494949;
      //   display: flex;
      //   justify-content: space-between;
      //   // align-items: center;
      //   // border: 1px solid red;
      //   // margin-top: 20px;

      //   .meiyi {
      //     font-size: 16px;
      //     font-family: NotoSansHans-Regular, NotoSansHans;
      //     font-weight: 400;
      //     color: #ffffff;
      //     margin-top: 10px;
      //   }
      //   .meiyi2 {
      //     position: relative;
      //     font-size: 16px;
      //     .navdown {
      //       width: 210px;
      //       height: 260px;
      //       // border: 1px solid #cccccc;
      //       position: absolute;
      //       // visibility: hidden;
      //       top: 25px;
      //       display: flex;
      //       flex-direction: column;
      //       left: 5px;
      //       span {
      //         margin-top: 10px;
      //       }
      //     }
      //   }
      //   // .meiyi2:hover .navdown {
      //   //   visibility: visible;
      //   // }
      //   // .meiyi:hover {
      //   //   font-weight: bold;
      //   //   color: #2973df;
      //   //   cursor: pointer;
      //   // }
      // }
      // .down {
      //   display: flex;
      //   align-items: center;
      //   justify-content: space-between;
      //   margin-top: 50px;
      //
      // }
      .left-bottom {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .tel {
        display: flex;
        align-items: center;
        img {
          margin-right: 15px;
        }
        span {
          font-size: 42px;
          line-height: 1;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
    .right {
      width: 35%;
      height: 220px;
      // border: 1px solid red;
      .top {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        ::v-deep .el-input__inner {
          background-color: #0e2033 !important;
          color: #fff !important;
        }
      }
      .more {
        width: 100%;
        height: 100px;
        ::v-deep .el-textarea__inner,
        .el-input__inner {
          background: #0e2033;
          color: #fff !important;
        }
        //   border: 1px solid red;
      }
    }
    .tel {
      display: flex;
      align-items: center;
      img {
        margin-right: 15px;
      }
      span {
        font-size: 23px;
        font-family: Frick0.3-Condensed, Frick03;
        font-weight: normal;
        color: #ffffff;
      }
    }
  }
  .beian {
    width: 60%;
    margin: 0 auto;
    // border: 1px solid red;
    display: flex;
    justify-content: space-between;

    span {
      width: 50%;
      // border: 1px solid red;
      font-size: 16px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #848c93;
      text-align: center;
    }
  }
}
</style>
